import React from 'react';
import SEO from '../../components/SEO/SEO';
import SubServiceTemplate from '../../components/SubServiceTemplate/SubServiceTemplate';

const ShopifyDevelopment = () => {
  const pageData = {
    category: "SHOPIFY DEVELOPMENT",
    title: "Shopify E-Commerce Development",
    description: "Build high-converting Shopify stores with custom themes, app integrations, and seamless checkout experiences. Perfect for businesses that need a powerful, scalable e-commerce platform with minimal maintenance.",

    features: [
      {
        title: "Custom Shopify Theme Development",
        description: "Fully custom Shopify themes built with Liquid, HTML, CSS, and JavaScript to match your brand identity perfectly."
      },
      {
        title: "Shopify App Integration",
        description: "Strategic integration of essential Shopify apps for inventory management, marketing automation, and customer experience."
      },
      {
        title: "Conversion Rate Optimization",
        description: "Optimize product pages, checkout flow, and user experience to maximize conversions and average order value."
      },
      {
        title: "Shopify Plus Development",
        description: "Enterprise-level Shopify Plus stores with advanced customization, wholesale channels, and multi-currency support."
      },
      {
        title: "Shopify SEO Optimization",
        description: "Technical SEO setup, optimized product schemas, meta tags, and site structure for maximum search visibility."
      },
      {
        title: "Migration & Data Transfer",
        description: "Seamless migration from WooCommerce, Magento, or other platforms to Shopify with zero downtime."
      }
    ],

    benefits: [
      {
        title: "All-in-One Platform",
        description: "Hosting, security, payment processing, and inventory management all included — no separate services needed."
      },
      {
        title: "Scalable Infrastructure",
        description: "Handle thousands of concurrent visitors and transactions without performance degradation or downtime."
      },
      {
        title: "Easy Store Management",
        description: "Intuitive admin dashboard makes it simple to manage products, orders, customers, and marketing campaigns."
      },
      {
        title: "Global Commerce Ready",
        description: "Built-in multi-currency support, international shipping, and localization for worldwide sales."
      }
    ],

    process: [
      {
        title: "Store Planning & Strategy",
        description: "Define product catalog, customer journey, checkout flow, and identify necessary apps and integrations."
      },
      {
        title: "Design & Theme Development",
        description: "Create custom Shopify theme or customize existing theme with your branding, layouts, and unique features."
      },
      {
        title: "Product Setup & Configuration",
        description: "Upload products, configure variants, set up collections, payment gateways, and shipping zones."
      },
      {
        title: "Testing, Launch & Training",
        description: "Comprehensive testing of checkout flow, payment processing, and provide training on store management."
      }
    ],

    relatedServices: [
      {
        title: "WordPress Development",
        description: "WooCommerce solutions for content-heavy e-commerce",
        link: "/services/web-development/wordpress"
      },
      {
        title: "Custom Websites",
        description: "Headless e-commerce with React and custom APIs",
        link: "/services/web-development/custom-websites"
      },
      {
        title: "Paid Advertising",
        description: "Drive traffic to your Shopify store with ads",
        link: "/services/paid-ads"
      }
    ],

    ctaText: "Ready to launch a high-converting Shopify store? Let's build an e-commerce experience your customers will love.",
    ctaLink: "/contact",
    parentLink: "/services/web-development",
    parentTitle: "Web Development"
  };

  return (
    <>
      <SubServiceTemplate {...pageData} />
      
            <SEO 
                title="Shopify Development Services" 
                description="Learn more about our Shopify Development services to grow your business online with Digi Network." 
                canonical="/web-development/shopify-development" 
            />

    </>
  );
};

export default ShopifyDevelopment;
